import { assertNever } from '@/globals/helpers/assert.helpers';
import { QuestionType } from './question.types';
import {
	SingleSelectConditionMethods,
	SingleSelectQuestionMethods,
} from './singleSelect/SingleSelectMethods';
import {
	MultipleSelectConditionMethods,
	MultipleSelectQuestionMethods,
} from './multipleSelect/MultipleSelectMethods';
import {
	MatrixConditionMethods,
	MatrixQuestionMethods,
} from './matrix/MatrixMethods';
import {
	BaseConditionMethods,
	BaseQuestionMethods,
} from './questionMethods.types';

export const getQuestionMethods = (type: QuestionType): BaseQuestionMethods => {
	switch (type) {
		case 'single':
			return SingleSelectQuestionMethods as BaseQuestionMethods;
		case 'multiple':
			return MultipleSelectQuestionMethods as BaseQuestionMethods;
		case 'matrix':
			return MatrixQuestionMethods as BaseQuestionMethods;
		default:
			return assertNever(type, `No question methods for type ${type}`);
	}
};

export const getConditionMethods = (
	type: QuestionType,
): BaseConditionMethods => {
	switch (type) {
		case 'single':
			return SingleSelectConditionMethods as BaseConditionMethods;
		case 'multiple':
			return MultipleSelectConditionMethods as BaseConditionMethods;
		case 'matrix':
			return MatrixConditionMethods as BaseConditionMethods;
		default:
			return assertNever(type, `No question methods for type ${type}`);
	}
};
